export default "__VITE_ASSET__Ce761teW__"